export default __webpack_public_path__ + "static/img_1_2-8a35dcbb69e1109bfcdd63c7a50aa419.jpg";